class multistoreRecommendations {
  constructor() {
    this.productId = null;
    this.popupOverlay = null;
  }

  init() {
    let _this = this;
    this.bindEvents();
    this.updateHiddenInputs();

    document.addEventListener('theme:cartchanged', (e) => {
      _this.handleCartChanged(e);
    });

    document.addEventListener('swatch-clicked', (e) => {
      // Add a small delay to make sure all events were dispatched and all elements were updated
      setTimeout(() => {
        _this.handleSwatchClicked();
      }, 25);
    });
  }
  
  bindEvents() {
    let _this = this;

    this.productId = document.querySelector('input[name="product-id"]').value;
    if(document.querySelector('.recommendations--popup-overlay')) {
      if(!this.popupOverlay) this.popupOverlay = document.querySelector('.recommendations--popup-overlay');

      this.popupOverlay.querySelectorAll('.close, .keep-shopping').forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          _this.closePopup();
        });
      });
    }

  }

  handleCartChanged(event) {
    let addedItem = event.detail;
    if(addedItem) {
      // updated to not trigger native recommendations at all
      let useNativeRecommendations = false;
      let openPopup = false;
      if(addedItem.hasOwnProperty('properties') && addedItem.properties.hasOwnProperty('_multistore_recommended_products')) {
        let recommendationsText = addedItem.properties._multistore_recommended_products;
        //useNativeRecommendations = recommendationsText.length < 1;
        openPopup = recommendationsText.length > 0;
      }

      if(openPopup) {
        this.openPopup();
        this.buildRecommendations(addedItem, useNativeRecommendations);
      }
    }
  }

  handleSwatchClicked() {
    this.productId = document.querySelector('input[name="product-id"]').value;
    this.popupOverlay = document.querySelector(`.recommendations--popup-overlay[data-id="${this.productId}"]`);
    this.updateHiddenInputs();

    document.querySelectorAll(`.recommendations--popup-overlay:not([data-id="${this.productId}"])`).forEach(function (el) {
      el.classList.remove('active');
      el.classList.add('hidden');
    });
    this.popupOverlay.classList.remove('hidden');
    this.bindEvents();
  }

  updateHiddenInputs() {
    if(!this.productId) return;
    let inputTarget = document.querySelector(`.multistore-recommendations-hidden-input[data-id="${this.productId}"]`);

    if(document.querySelector('input[name="properties[_multistore_recommended_products]"]')) {
      document.querySelector('input[name="properties[_multistore_recommended_products]"]').setAttribute('name','');
    }

    if (!inputTarget) return;

    let defaultTargetName = inputTarget.dataset.name;
    inputTarget.setAttribute('name', defaultTargetName);
  }

  buildRecommendations(addedItem, useNativeRecommendations) {
    let _this = this;
    let addedCont = this.popupOverlay.querySelector('.added-product');
    if(!addedCont) return;

    //if(useNativeRecommendations) {
      let multistoreRecommendations = _this.popupOverlay.querySelector('.recommendations-list--container > .recommendations-list');
      let nativeRecommendations = _this.popupOverlay.querySelector('.shopify-recommendations-list');

      multistoreRecommendations.classList.toggle('hidden', useNativeRecommendations);
      nativeRecommendations.classList.toggle('hidden', !useNativeRecommendations);
    //}

    $(_this.popupOverlay).find('.recommendations-list:not(.hidden), .shopify-recommendations-list:not(.slick-initialized):not(.hidden) .recommendations-list').slick({
      infinite: false,
      slidesToShow: 3,
      arrows: false,

      responsive: [{

        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }

      }]
    });

    if(addedItem) {
      let imgTarget = addedCont.querySelector('.added-product--image img');
      let titleTarget = addedCont.querySelector('.added-product--title');
      let optionsTarget = addedCont.querySelector('.added-product--options');
      let qtyTarget = addedCont.querySelector('.added-product--quantity');
      let priceTarget = addedCont.querySelector('.added-product--price');

      if(imgTarget && addedItem.hasOwnProperty('featured_image') && addedItem.featured_image.hasOwnProperty('url')) {
        imgTarget.setAttribute('src', addedItem.featured_image.url);
      }
      if(titleTarget && addedItem.hasOwnProperty('untranslated_product_title')) {
        titleTarget.innerText = addedItem.untranslated_product_title;
      }
      if(optionsTarget && addedItem.hasOwnProperty('variant_title')) {
        optionsTarget.innerText = addedItem.variant_title;
      }
      if(qtyTarget && addedItem.hasOwnProperty('quantity')) {
        qtyTarget.innerText = 'x' + addedItem.quantity;
      }
      if(priceTarget && addedItem.hasOwnProperty('price')) {
        priceTarget.innerText = '$' + (addedItem.price / 100).toFixed(2);
      }
    }

    this.bindEvents();
    this.openPopup();

  }

  openPopup() {
    this.popupOverlay.classList.add('active');
    document.querySelector('body').classList.add('noscroll');
    this.popupOpen = true;
  }

  closePopup() {
    this.popupOverlay.classList.remove('active');
    document.querySelector('body').classList.remove('noscroll');
    this.popupOpen = false;
    $('.recommendations-list.slick-initialized').slick('unslick');
  }
}


let multistore_recommendations = new multistoreRecommendations();
multistore_recommendations.init();